export const sendAnalyticEvent = (eventName: string, params?: object): void => {
    window.ym(54592891, 'reachGoal', eventName, {
        ...params,
        locale: process.env.REACT_APP_LOCALE,
    });
};
